import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

import axios from './_defaults/api';
import anonymous from './_defaults/anonymous';

export async function signup({data}) {
    try {
        const response = await anonymous.post("/auth/oauth/credentials", data);

        return decodeToken(response);

    } catch(error) {
        console.log("ERROR signup");
        throw error;
    }
}

export async function login({data}) {
    try {
        const response = await anonymous.post("/auth/oauth/credentials", data);

        return decodeToken(response);
    } catch(error) {
        console.log("ERROR login");
        throw error;
    }
}

export function logout() {

    Cookies.remove('user-authorization', {domain: process.env.REACT_APP_COOKIE_DOMAIN})
    Cookies.remove('user-refreshToken', {domain: process.env.REACT_APP_COOKIE_DOMAIN})
    Cookies.remove('user-id', {domain: process.env.REACT_APP_COOKIE_DOMAIN})
    Cookies.remove('activity-id')
    Cookies.remove('organization-id');

    return true
}

export async function refreshUser() {
    try {

        let refreshToken = Cookies.get('user-refreshToken');
        let userId = Cookies.get('user-id');

        if(!refreshToken || !userId) {
            return;
        }

        const response = await axios.post("/auth/refresh", {_id: userId, refreshToken});

        return decodeToken(response);
    } catch(error) {
        logout();
        throw error;
    }
}

export async function askUserPassword({data}) {
    const response = await axios.post("/auth/password/ask", data);

    if (response.data) {
        return response.data;
    }

    return response;
}

export async function resetUserPassword({data}) {
    const response = await axios.post("/auth/password/reset", data);

    if (response.data) {
        return response.data;
    }

    return response;
}

function decodeToken(response) {

    if (response.data && response.data.auth) {

        const user = jwtDecode(response.data.token);

        const expires = differenceInCalendarDays(new Date(), new Date(user.exp));
        Cookies.set('user-authorization', response.data.token, { expires, domain: process.env.REACT_APP_COOKIE_DOMAIN });
        Cookies.set('user-refreshToken', response.data.refreshToken, { expires, domain: process.env.REACT_APP_COOKIE_DOMAIN })
        Cookies.set('user-id', user._id, { expires, domain: process.env.REACT_APP_COOKIE_DOMAIN })

        return user.profile
    }

    return response
}